enum Flags {
  isInitializedUserConfigCat = 'isInitializedUserConfigCat',
  isLoginActive = 'isLoginActive',
  isPermissionsActive = 'isPermissionsActive',
  isEnergyContractsActive = 'isEnergyContractsActive',
}

export default Flags
